import React, { useCallback } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Checkbox, CheckboxLabel, CheckboxCount } from './styles';

interface Props {
  travelPolicies: { text: string; }[];
  values: string[];
  onChange: (values: string[]) => void;
  onOptionChange?: (value: string, isChecked: boolean) => void;
}

const TravelPolicies = ({ travelPolicies, values, onChange, onOptionChange }: Props) => {
  const { t } = useStoreTranslation();

  const isChecked = useCallback((checkValue: string) => Boolean(values.find((item) => item === checkValue)), [values]);

  const handleChange = (newValue: string) => {
    if (isChecked(newValue)) {
      onChange([...new Set(values.filter((item) => item !== newValue))]);
    } else {
      onChange([...new Set([...values, newValue])]);
    }
    if (onOptionChange) onOptionChange(newValue, !isChecked(newValue));
  };

  return (
    <section>
      {travelPolicies.map((travelPolicies) => {

        const label = (() => {
          switch (travelPolicies.text) {
            case 'outOfPolicies':
              return t('flightsFilters.travelPolicies.outOfPolicies');
            default:
              return t('flightsFilters.travelPolicies.withInPolicies');
          }
        })();

        return (
          <Checkbox key={travelPolicies.text} checked={isChecked(travelPolicies.text)} onChange={() => handleChange(travelPolicies.text)}>
            <CheckboxLabel content={t(label)} onClick={() => handleChange(travelPolicies.text)} />
            <CheckboxCount/>
          </Checkbox>
        );
      })}
    </section>
  );
};

export default TravelPolicies;
